import { SvgIcon, SvgIconProps } from '@mui/material'

export function LayersIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.837 1.194a.5.5 0 0 1 .326 0L14.83 3.5a.5.5 0 0 1 .004.944L8.167 6.805a.5.5 0 0 1-.334 0L1.166 4.443A.5.5 0 0 1 1.17 3.5l6.667-2.305Zm-4.99 2.784L8 5.803l5.153-1.825L8 2.196 2.847 3.978Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.861 6.502a.5.5 0 0 1 .638-.307L8 8.471l6.502-2.276a.5.5 0 1 1 .33.944L8.165 9.472a.5.5 0 0 1-.33 0L1.168 7.14a.5.5 0 0 1-.307-.637Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.861 9.168a.5.5 0 0 1 .638-.307L8 11.137l6.502-2.276a.5.5 0 1 1 .33.944l-6.667 2.333a.5.5 0 0 1-.33 0L1.168 9.805a.5.5 0 0 1-.307-.637Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.861 11.835a.5.5 0 0 1 .638-.307L8 13.804l6.502-2.276a.5.5 0 1 1 .33.944l-6.667 2.333a.5.5 0 0 1-.33 0l-6.667-2.333a.5.5 0 0 1-.307-.637Z"
        fill="#1C1B1E"
      />
    </SvgIcon>
  )
}

export default LayersIcon
